import { render, staticRenderFns } from "./MatchTypeGuide.vue?vue&type=template&id=2180fb71&scoped=true"
import script from "./MatchTypeGuide.vue?vue&type=script&lang=js"
export * from "./MatchTypeGuide.vue?vue&type=script&lang=js"
import style0 from "./MatchTypeGuide.vue?vue&type=style&index=0&id=2180fb71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180fb71",
  null
  
)

export default component.exports